<template>
  <ConfirmationDialog :value="open" submitText="SAVE" cancelText="CLOSE" @confirmed="save" @close="cancel">

    <template #title>
      Close ticket {{ getCurrentTicket.id }}
    </template>

    <template #text>
      <v-select v-model="resolution" label="Resolution" placeholder="Select an option" :items="options" @change="$v.resolution.$touch()" @blur="$v.resolution.$touch()" :error-messages="resolutionErrors" dense outlined hide-details="auto" ></v-select>
    </template>

  </ConfirmationDialog>
</template>

<script>
  import { mapGetters } from 'vuex';
  import { validationMixin } from 'vuelidate';
  import { required } from 'vuelidate/lib/validators';

  import ConfirmationDialog from '@/components/Globals/ConfirmationDialog';

  export default {
    components: {ConfirmationDialog},

    mixins: [validationMixin],

    validations: {
      resolution: { required },
    },

    props: {
      open: {
        type: Boolean,
        default: false
      }
    },
    
    data() {
      return {
        resolution: '',
        options: [
          {text: 'Resolved', value: 'Resolved'},
          {text: 'Not Resolved', value: 'Not Resolved'},
          {text: 'No Contact', value: 'No Contact'}
        ]
      }
    },

    computed: {
      ...mapGetters('tickets', ['getCurrentTicket']),

      resolutionErrors() {
        const errors = [];
        if (!this.$v.resolution.$dirty) return errors;
        !this.$v.resolution.required && errors.push('Resolution is a required field');

        return errors;
      }
    },

    methods: {
      save() {
        this.$v.$touch();

        if (!this.$v.$invalid) { 
          this.$emit('updateStatus', this.resolution);
          this.cancel();
        }
      },

      resetForm() {
        this.$v.$reset();
        this.resolution = '';
      },

      cancel() {
        this.resetForm();
        this.$emit('closeDialog');
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>